var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2047 73.3459L14.8703 77.6803C12.4761 80.0745 8.59221 80.0745 6.19797 77.6803L1.86359 73.3459C-0.530655 70.9548 -0.530655 67.0678 1.86359 64.6768L6.19797 60.3424L19.2045 73.3456L19.2047 73.3459ZM8.36529 36.4959C10.7595 34.1048 14.6434 34.1048 17.0377 36.4959L43.0482 62.5097C45.4425 64.9008 45.4425 68.7878 43.0482 71.1788L38.7138 75.5132C36.3196 77.9074 32.4357 77.9074 30.0415 75.5132L4.03091 49.5026C1.63985 47.1084 1.63985 43.2245 4.03091 40.8335L8.36529 36.4959ZM36.5462 47.3353L58.4523 25.4267C59.6478 24.2312 59.6478 22.2879 58.4523 21.0924C57.2568 19.8968 55.3135 19.8968 54.1179 21.0924L32.2094 43.0009L22.5225 33.3108L40.8114 8.43818C41.268 7.81902 41.9396 7.39274 42.6966 7.24584L74.9787 0.973762C75.9782 0.780571 77.0111 1.09638 77.7315 1.81672C78.452 2.53706 78.7678 3.56722 78.5713 4.5664L72.2992 36.8517C72.152 37.606 71.7261 38.2804 71.1069 38.7369L46.2342 57.0226L36.5474 47.3357L36.5462 47.3353Z",
    fill: "#C3E2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3);
export default __webpack_public_path__ + "static/media/home3.3cd193189fb1f9eb1b01949a1be47280.svg";
export { ForwardRef as ReactComponent };